<template>
  <div>
    <div class="col-12 mt2 white-bg px1 pb1">
      <div class="flex justify-center">
        <h5 class="violet m1 h6">{{ title }}</h5>
      </div>
      <div v-if="!loading">
        <!-- <div v-if="!isInvite">
          DESKTOP
          <div class="xs-hide sm-hide mt2 flex items-center">
            <span class="mr2 h6">Est-ce que tu joues aussi ?</span>
            <div class="flex items-center h6">
              <span class="mr1">Oui</span>
              <CourtSwitch v-model="isCaptainNotPlaying" switch-color="light-cyan" inverted />
              <span class="ml1">Non</span>
            </div>
          </div>

          MOBILE
          <div class="md-hide lg-hide mt2 flex items-center">
            <span class="mr2 h7">Est-ce que tu joues aussi ?</span>
            <div class="flex items-center h7">
              <span class="mr1">Oui</span>
              <CourtSwitch v-model="isCaptainNotPlaying" switch-color="light-cyan" inverted />
              <span class="ml1">Non</span>
            </div>
          </div>
        </div> -->

        <TerrainHeader :show-participant-card="true" />

        <div v-if="isInvite" class="light-grey-bg px2 pb2">
          <div class="flex items-center">
            <img :src="imagePath('icons/violet-check-icon.svg')" class="mr2" alt="icon-violet-check" width="26" height="26">
            <h3 class="bold">Je rejoins la partie</h3>
          </div>

          <div class="flex white-bg p2">
            <div class="col-8">
              <span class="col-4 cust-border light-grey-bg h6 items-center p1" :style="{ '--cust-border-color': 'medium-grey', '--cust-border-radius': '0px' }">
                {{ haveSubscription ? 'Abonné(e)' : 'Non abonné(e)' }}
              </span>
              <div class="col-12">
                <span class="h6">
                  {{ gender }} {{ user.firstname }} {{ user.lastname }}
                </span>
              </div>
            </div>
            <div class="col-4 h6">
              <span :class="{ 'crossed': hasPromo }">{{ price }} €</span>
              <span v-if="hasPromo" class="ml1">{{ discountPrice }} €</span>
            </div>
          </div>
        </div>

        <div v-if="!haveSubscription" class="mt2">
          <!-- DESKTOP -->
          <div class="xs-hide sm-hide flex items-center">
            <span class="mr2 h6 bold">Avez-vous le code EGYM Wellpass ?</span>
            <div class="flex items-center h6">
              <span class="mr1">Non</span>
              <CourtSwitch v-model="haveGymLibCode" switch-color="light-cyan" />
              <span class="ml1">Oui</span>
            </div>
          </div>
          <!-- MOBILE -->
          <div class="md-hide lg-hide flex items-center">
            <span class="mr2 h7 bold">Avez-vous le code EGYM Wellpass ?</span>
            <div class="flex items-center h7">
              <span class="mr1">Non</span>
              <CourtSwitch v-model="haveGymLibCode" switch-color="light-cyan" />
              <span class="ml1">Oui</span>
            </div>
          </div>

          <GymlibCodeValidator
            v-if="haveGymLibCode && !showPromoCodeInput"
            :price="10"
            class="col-12"
            btn-color="violet-bg white"
            :remove-padding="true"
            label="OK"
            @validate-code="validateGymlibCode"
            @gym-lib-code-changed="gymLibCodeChanged"
          />

          <!-- DESKTOP -->
          <div class="xs-hide sm-hide mt2 flex items-center">
            <span class="mr2 h6 bold">Avez-vous un code promo ?</span>
            <div class="flex items-center h6">
              <span class="mr1">Non</span>
              <CourtSwitch v-model="showPromoCodeInput" switch-color="light-cyan" />
              <span class="ml1">Oui</span>
            </div>
          </div>
          <!-- MOBILE -->
          <div class="md-hide lg-hide mt2 flex items-center">
            <span class="mr2 h7 bold">Avez-vous un code promo ?</span>
            <div class="flex items-center h7">
              <span class="mr1">Non</span>
              <CourtSwitch v-model="showPromoCodeInput" switch-color="light-cyan" />
              <span class="ml1">Oui</span>
            </div>
          </div>

          <div v-if="showPromoCodeInput && !haveGymLibCode">
            <div v-if="!loadingPromoCode">
              <!-- DESKTOP -->
              <div class="xs-hide sm-hide flex col-12 pr1 flex-grow mt3">
                <input v-model="promoCode" type="text" placeholder="code promo" class="h5n flex-grow p2">
                <Button
                  class="no-wrap h5n transparent-bg border-none bold"
                  :action="() => validatePromoCode()"
                  text="OK"
                  color="violet-bg"
                  :disabled="!promoCode"
                  full-height
                  text-size="h5n"
                  :text-caps="false"
                />
              </div>
              <!-- MOBILE -->
              <div class="md-hide lg-hide flex col-12 pr1 flex-grow mt2">
                <input v-model="promoCode" type="text" placeholder="code promo" class="h6 flex-grow p15">
                <Button
                  class="no-wrap h6 transparent-bg border-none bold"
                  :action="() => validatePromoCode()"
                  text="OK"
                  color="violet-bg"
                  :disabled="!promoCode"
                  full-height
                  text-size="h6"
                  :text-caps="false"
                />
              </div>
            </div>
            <div v-else class="flex justify-center items-center ml2">
              <Loader />
            </div>

            <div v-if="promoCode" class="flex justify-center mt1">
              <div v-if="isPromoCodeValid" class="flex green h6">Code appliqué</div>
              <div v-if="!isPromoCodeValid && errorMessage" class="flex red h6">{{ errorMessage }}</div>
            </div>
          </div>
        </div>

        <div v-if="isInvite" class="mt2 h4 flex justify-center">
          Coéquipiers déjà inscrits : {{ sessionParticipantsAmount }}
        </div>

        <StepAction text-size="h6" :disabled="isAdvanceBtnDisabled" @handleClickAction="handleParticipantStep" />
      </div>
      <Loader v-else />
    </div>
  </div>
</template>

<script setup>

import { ref, watch, onBeforeMount, computed, inject } from 'vue';

import { useRoute } from 'vue-router';
import CourtSwitch from '@/components/terrain/CourtSwitch.vue';
import TerrainHeader from '@/components/terrain/TerrainHeader.vue';

import StepAction from '@/components/terrain/StepAction.vue';

import { useStore } from '@/store/index';
import Button from '@/components/elements/Button.vue';
import Loader from '@/components/elements/Loader.vue';
import GymlibCodeValidator from '@/components/tariffs/GymlibCodeValidator.vue';

import { getParticipantActiveSubscriptionsInfo, getSharegroopCustomerInfo, submitPromoCode, getCustomerAmplifySubscriptionContract } from '@/utils/requests';
import { computePriceLabel, capitalizeFirstLetter, assetsPath } from '@/utils/utils';
import { computeCourtDataLayer } from '@/utils/index';

const handleStepVisibility = inject('handleStepVisibility');

const store = useStore();
const route = useRoute();

const advanceStep = inject('advanceStep');

const isCaptainPlaying = ref(store?.state?.courtSettings?.isCaptainPlaying || true);
// const isCaptainNotPlaying = ref(!store?.state?.courtSettings?.isCaptainPlaying || false);
const loading = ref(false);
const haveGymLibCode = ref(false);
const loadingPromoCode = ref(false);
const promoCode = ref(null);
const isPromoCodeValid = ref(false);
const errorMessage = ref(null);
const gymlibCode = ref(null);
const showPromoCodeInput = ref(false);

const hasPromo = computed(() => store.state.courtSettings.isPromoCodeValid);

const offerInfo = computed(() => store.state.offerInfo);

const user = computed(() => store.state.user);

const isInvite = computed(() => store.state.courtSettings.isInvite);

const haveSubscription = computed(() => store.state.courtSettings.haveSubscription);

const captain = computed(() => store.state.courtSettings?.session?.captain);

const sessionParticipantsAmount = computed(() => store.state.courtSettings?.session?.sessionParticipantsCount || (store.state.courtSettings?.session?.participants || []).length);

const title = computed(() => (isInvite.value ? `${captain.value?.firstname || ''} t’invite à rejoindre sa partie` : `Tu organises une partie de ${offerInfo.value.filliere}!`));

const gender = computed(() => capitalizeFirstLetter(user.value.gender));

const isAdvanceBtnDisabled = computed(() => {
  if (haveGymLibCode.value) {
    return gymlibCode.value && !isPromoCodeValid.value;
  }
  if (showPromoCodeInput.value && !haveGymLibCode.value && promoCode.value) {
    return promoCode.value && !isPromoCodeValid.value;
  }
  return false;
});

const price = computed(() => {
  const computedPrice = (haveSubscription.value ? 0 : store.state.courtSettings.tariff.price);

  return computePriceLabel(computedPrice);
});

const discountPrice = computed(() => {
  if (haveSubscription.value || (haveGymLibCode.value && isPromoCodeValid.value)) {
    return 0;
  }
  const promoAmount = (store.state.courtSettings.tariff.price * store.state.courtSettings.promoCampaign.discount) / 100;

  return computePriceLabel(Math.round(store.state.courtSettings.tariff.price - promoAmount));
});

const handleParticipantStep = () => {
  computeCourtDataLayer('CourtParticipants', { ...store.state.courtSettings }, route.fullPath, { ...store.state.product }, { ...store.state.offerInfo });

  if (!isInvite.value && !isCaptainPlaying.value) {
    handleStepVisibility('CourtOptions', false);
  }
  advanceStep();
};

const validateGymlibCode = async isCodeValid => {
  isPromoCodeValid.value = isCodeValid;

  if (isCodeValid) {
    handleStepVisibility('CourtOptions', false);
  }

  store.commit('setCourtSettings', { ...store.state.courtSettings, promoCode: gymlibCode.value, haveGymLibCode: haveGymLibCode.value, isPromoCodeValid: isCodeValid });
};

const gymLibCodeChanged = async code => {
  gymlibCode.value = code;
  store.commit('setCourtSettings', { ...store.state.courtSettings, promoCode: gymlibCode.value });
};

const validatePromoCode = async () => {
  loadingPromoCode.value = true;

  if (haveGymLibCode.value) {
    return;
  }

  await submitPromoCode({ workspace: store.state.siteInfo.workspace, promoCode: promoCode.value, productUuid: store.state.product.uuid, horanetProductCode: store.state.offerInfo.horanet_product.horanet_product_code }).then(r => {
    const { success, message, data } = r;
    isPromoCodeValid.value = success;
    errorMessage.value = message || 'Code invalide';

    if (success) {
      store.commit('setCourtSettings', { ...store.state.courtSettings, promoCode: promoCode.value, isPromoCodeValid: isPromoCodeValid.value, promoCampaign: data });
    }
  }).finally(() => {
    loadingPromoCode.value = false;
  });
};

const imagePath = name => `${assetsPath()}img/${name}`;

// watch(isCaptainNotPlaying, newVal => {
//   store.commit('setCourtSettings', { ...store.state.courtSettings, isCaptainPlaying: !newVal });
// });

watch(showPromoCodeInput, newVal => {
  if (newVal === true) {
    haveGymLibCode.value = false;
  }
});

watch(haveGymLibCode, newVal => {
  if (newVal && newVal === true) {
    showPromoCodeInput.value = false;
  }
});

onBeforeMount(async () => {
  loading.value = true;

  const promises = [getSharegroopCustomerInfo(store.state.user.uuid, store.state.siteInfo.workspace), getCustomerAmplifySubscriptionContract(store.state.siteInfo.workspace)];

  const [sgCustomerInfo, amplifyContracts] = await Promise.all(promises);

  let customerSubscriptionContract = null;
  if (amplifyContracts && amplifyContracts.length) {
    const response = await getParticipantActiveSubscriptionsInfo(store.state.siteInfo.workspace);
    customerSubscriptionContract = amplifyContracts.find(amplifyContract => {
      const subscriptionCanBeUsedOnsession = store.state.courtSettings.session.detail.serviceIds.some(sessionService => amplifyContract.serviceIds.some(contractService => contractService.id.toString() === sessionService.id.toString()));

      if (!subscriptionCanBeUsedOnsession) {
        return false;
      }

      const sgSubscription = (response.sharegroopCustomer.subscriptions || []).find(sgSub => sgSub.trackId === amplifyContract.orderId);

      if (sgSubscription) {
        return sgSubscription.status === 'active';
      }

      const stripeSubscription = (response.stripeCustomer.subscriptions || []).find(stripeSub => stripeSub.orderUuid === amplifyContract.orderId || stripeSub?.metadata?.numeroSerieSupport === amplifyContract.qrcode);

      if (stripeSubscription) {
        return stripeSubscription.status === 'active';
      }

      return true;
    });
  }

  // const customerHaveSubscription = response?.subscriptions?.some(subscription => subscription?.items?.some(item => store.state.courtSettings?.sessionServices?.some(service => service?.productRef === item?.metadata?.productReference)));

  store.commit('setCourtSettings', { ...store.state.courtSettings, sharegroopInfo: sgCustomerInfo, haveSubscription: !!customerSubscriptionContract, subscriptionContract: customerSubscriptionContract });

  loading.value = false;
});

</script>
